import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class AddressService extends BaseService {

    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    get(data): Observable<any> {
        return this.getRequest(AppUrl.ADDRESS(), data);
    }

    count(): Observable<any> {
        return this.getRequest(AppUrl.ADDRESS_COUNT());
    }

    detail(id): Observable<any> {
        return this.getRequest(AppUrl.ADDRESS(id));
    }

    getAddressByPos(id): Observable<any> {
        return this.getRequest(AppUrl.ADDRESS_BY_POS(id));
    }

    create(data): Observable<any> {
        return this.postRequest(AppUrl.ADDRESS(), data);
    }

    createByPos(id, data): Observable<any> {
        return this.postRequest(AppUrl.ADDRESS_ADD_BY_POS(id), data);
    }

    updateStatus(id, userId, data): Observable<any> {
        return this.putRequest(AppUrl.UPDATE_ADDRESS_STATUS(id, userId), data);
    }
}
